export default __webpack_public_path__ + "static/events-light-464c9cfaf80a6e8ca9c8181e7f9a4c26.png";